import React, { PureComponent } from 'react';
import { CfmuFlightType, FlightId, Slot, SlotForcedType, SlotStatus, SlotType, SlotUpdateKind } from 'app/model/CORE';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import AppContext from 'app/common/context/AppContext';
import { PopoverMenu } from 'app/components/common/PopoverMenu';
import { MoreOutlined } from '@ant-design/icons';
import { ShowModalEvent } from 'app/common/eventbus/Events';
import Utils from 'app/common/util/Utils';
import { BookSlotPanel } from 'app/components/panels/slot/BookSlotPanel';
import TimeUtils from 'app/common/util/TimeUtils';

interface SlotMoreMenuProps {
    slot: Slot;
    onBookSlot: (slot: Slot, flightId: FlightId) => void;
    onFreeSlot: (slot: Slot) => void;
    onUpdateSlot: (slot: Slot, updateKind: SlotUpdateKind) => void;
}

export class SlotMoreMenu extends PureComponent<SlotMoreMenuProps> {
    private handleMoreMenuItemClick = (key: string) => {
        const slot = this.props.slot;

        switch (key) {
            case 'delete-slot':
                this.props.onUpdateSlot(slot, SlotUpdateKind.DELETE_SLOT);
                break;
            case 'block-slot':
                this.props.onUpdateSlot(slot, SlotUpdateKind.BLOCK_SLOT);
                break;
            case 'book-slot':
                const content = (
                    <BookSlotPanel onSuccess={flightId => this.props.onBookSlot(this.props.slot, flightId)} />
                );
                AppContext.eventBus.publish(new ShowModalEvent(ShowModalEvent.NAME, content, '20em'));
                break;
            case 'unblock-slot':
                this.props.onUpdateSlot(slot, SlotUpdateKind.UNBLOCK_SLOT);
                break;
            case 'free-slot':
                this.props.onFreeSlot(slot);
                break;
        }
    };

    isDeleteSlotDisabled = (slot: Slot): boolean => {
        const slotFree = Utils.isInList(slot.status, SlotStatus.AVAILABLE, SlotStatus.PRE_ALLOCATED);
        const slotOverloaded = slot.type === SlotType.OVERLOAD;

        return !slotFree || slotOverloaded;
    };

    isBlockSlotDisabled = (slot: Slot): boolean => {
        const slotTimeInFuture = TimeUtils.compare(AppContext.getCurrentTime(), slot.referenceTime) < 0;
        const slotFree = Utils.isInList(slot.status, SlotStatus.AVAILABLE, SlotStatus.PRE_ALLOCATED);
        const slotOverloaded = slot.type === SlotType.OVERLOAD;

        return !slotTimeInFuture || !slotFree || slotOverloaded;
    };

    isBookSlotDisabled = (slot: Slot): boolean => {
        const slotTimeInFuture = TimeUtils.compare(AppContext.getCurrentTime(), slot.referenceTime) < 0;
        const slotFree = Utils.isInList(
            slot.status,
            SlotStatus.AVAILABLE,
            SlotStatus.PRE_ALLOCATED,
            SlotStatus.BLOCKED,
        );
        const slotOverloaded = slot.type === SlotType.OVERLOAD;

        return !slotTimeInFuture || !slotFree || slotOverloaded;
    };

    isUnbookSlotDisabled = (slot: Slot): boolean => {
        const slotTimeInFuture = TimeUtils.compare(AppContext.getCurrentTime(), slot.referenceTime) < 0;
        const slotBlocked = slot.status === SlotStatus.BLOCKED;
        const slotOverloaded = slot.type === SlotType.OVERLOAD;
        return !slotTimeInFuture || !slotBlocked || !slotOverloaded;
    };

    isFreeSlotDisabled = (slot: Slot): boolean => {
        const slotNotForced = slot.regulatedFlight?.forced === SlotForcedType.NOT_FORCED;
        const flightExempted = slot.regulatedFlight?.exempted;
        const flightActOrTer = Utils.isInList(
            slot.regulatedFlight?.cfmuFlightType,
            CfmuFlightType.ACT,
            CfmuFlightType.TERMINATED,
        );

        if (slot.regulatedFlight?.flightId?.flightKeys?.callsign === 'NSZ2CP') {
            console.log(Utils.isNotExists(slot.regulatedFlight), slotNotForced, flightExempted, flightActOrTer);
        }
        return Utils.isNotExists(slot.regulatedFlight) || slotNotForced || flightExempted || flightActOrTer;
    };

    render() {
        const menuItems: ItemType[] = [];
        const slot = this.props.slot;

        menuItems.push({ key: 'delete-slot', label: 'Delete slot', disabled: this.isDeleteSlotDisabled(slot) });
        menuItems.push({ key: 'block-slot', label: 'Block slot', disabled: this.isBlockSlotDisabled(slot) });
        menuItems.push({ key: 'book-slot', label: 'Book slot', disabled: this.isBookSlotDisabled(slot) });
        menuItems.push({
            key: 'unblock-slot',
            label: 'Un(block/book) slot',
            disabled: this.isUnbookSlotDisabled(slot),
        });
        menuItems.push({ key: 'free-slot', label: 'Free slot', disabled: this.isFreeSlotDisabled(slot) });

        return (
            <PopoverMenu onMenuItemClick={this.handleMoreMenuItemClick} menuItems={menuItems}>
                <MoreOutlined />
            </PopoverMenu>
        );
    }
}
